import React, { Component } from 'react';
import OdourIntensity from '../odour-intensity/OdourIntensity';
import GoogleSuggest from '../google-suggest/GoogleSugest';
import OdourCharacterSelect from '../odour-character-select/OdourCharacterSelect';
import { ValidatorComponent, ValidatorSummaryComponent, validatorClassList } from '../../services/validators';
import TimeRangeQuestion from '../TimeRangeQuestion'

import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

class OdourAssessment extends Component {
    state = {
        intensity: 0,
        startDate: new Date(),
        startTime: new Date(),
        endDate: null,
        endTime: null,
        characters: [],
        odourLevel: null,
        comments: '',
        isReceiveUpdate: 'no',
        email: null,
        canContact: 'no',
        name: null,
        phone: null
    };

    constructor() {
        super();

        this.submitClicked = () => {
            if (this.props.onSubmit) {
                this.props.onSubmit(this.state)
            }
        }
        this.locationChanged = (target) => {
            this.setState({ location: target.value });
        }
        this.intensityChanged = e => {
            this.setState({ intensity: e.intensity })
        }
        this.charactersChanged = e => {
            this.setState({ characters: e })
        }
        this.handleOdourLevelChange = (e) => {
            this.setState({ odourLevel: e.target.value })
        }
        this.handleReceiveUpdate = (e) => {
            this.setState({ isReceiveUpdate: e.target.value })
        }
        this.handleChange = event => {
            const { name, value } = event.target ? event.target : event
            this.setState({ [name]: value });
        }
    }


    render() {
        const validatorMessages = this.props.validatorMessages ? this.props.validatorMessages : [];
        const { startDate, startTime, endDate, endTime, intensity, odourLevel, comments, isReceiveUpdate } = this.state
        return (
            <div className="view-container">
                <div className="header-section">
                    <div className="heading">Welcome to Smelt-it!</div>
                    <div className="subheading">
                        Help us to help your neighbourhood
                    </div>
                </div>
                <div className={validatorClassList("question-section", "intensity", validatorMessages)}>
                    <span className="primary-question">1. How does the smell affect you?</span>
                    <label className="question-helper">
                        Select the correct strength using the scale and descriptions below
                    </label>
                    <OdourIntensity intensity={intensity} onChange={this.intensityChanged}></OdourIntensity>
                    <ValidatorComponent name='intensity' messages={validatorMessages}></ValidatorComponent>
                    {intensity > 1 &&
                        <>
                        <div className="question-divider"></div>
                        <span className="primary-question">
                            Are you ok with the level of odour?</span>
                        <div className="radio-wrapper">
                            <div className={odourLevel === 'acceptable' ? 'radio__item-active radio__item' : 'radio__item'}>
                                <input type="radio" onChange={this.handleOdourLevelChange} value="acceptable" name="odourlevel" id="olyes" checked={odourLevel === 'acceptable'} />
                                <label htmlFor="olyes">Acceptable</label>
                            </div>
                            <div className={odourLevel === 'objectionable' ? 'radio__item-active radio__item' : 'radio__item'}>
                                <input type="radio" onChange={this.handleOdourLevelChange} value="objectionable" name="odourlevel" id="olno" checked={odourLevel === 'objectionable'} />
                                <label htmlFor="olno">Objectionable</label>
                            </div>
                        </div>
                        <ValidatorComponent name='odourLevel' messages={validatorMessages}></ValidatorComponent>
                        </>
                    }
                </div>
                <div className={validatorClassList("question-section", "location", validatorMessages)}>
                    <span className="primary-question">2. Where were you?</span>
                    <label className="question-helper">
                        Note: We are currently only monitoring Smelt-it reports in limited areas.
                    </label>
                    {intensity > 1
                        ? <label className="question-helper">Confirm the address where you experienced the smell.</label>
                        : <label className="question-helper">Confirm the address of this odour report.</label>}
                    <GoogleSuggest onChange={this.locationChanged}></GoogleSuggest>
                    <ValidatorComponent name='location' messages={validatorMessages}></ValidatorComponent>
                </div>

                {intensity > 1 &&
                    <>

                    <TimeRangeQuestion
                        validatorMessages={validatorMessages}
                        startDate={startDate}
                        startTime={startTime}
                        endDate={endDate}
                        endTime={endTime}
                        onChange={this.handleChange}
                    />

                    <div className={validatorClassList("question-section", "characters", validatorMessages)}>
                        <span className="primary-question">4. What are the characters of the smell?</span>
                        <label className="question-helper">
                            Select what best describe the odour
                        </label>
                        <OdourCharacterSelect onChange={this.charactersChanged}></OdourCharacterSelect>
                        <ValidatorComponent name='characters' messages={validatorMessages}></ValidatorComponent>
                    </div>
                    <div className={validatorMessages.length ? "question-section question-section__error" : "question-section"}>
                        <span className="primary-question">5. Optional comment</span>
                        <label className="question-helper" htmlFor="comments">
                            Anything you want to add to describe the smell and your experience in no more than 500 characters
                        </label>
                        <textarea
                            name="comments"
                            id="comments"
                            value={comments}
                            onChange={this.handleChange}
                            maxLength={500}
                            className={'text-area'}
                        />
                    </div>
                    {isReceiveUpdate === 'yes' &&
                        <div className={validatorMessages.length ? "question-section question-section__error" : "question-section"}>
                            <span className="primary-question">Would you like to receive updates on this project?</span>
                            <label className="question-helper">
                                If you have provided your email in a previous Smelt-it report then you may skip this section.
                            </label>
                            <div className="radio-wrapper">
                                <div className={isReceiveUpdate === 'yes' ? 'radio__item-active radio__item' : 'radio__item'}>
                                    <input type="radio" onChange={this.handleReceiveUpdate} value="yes" name="isReceiveUpdate" id="iryes" checked={isReceiveUpdate === 'yes'} />
                                    <label htmlFor="iryes">Yes</label>
                                </div>
                                <div className={isReceiveUpdate === 'no' ? 'radio__item-active radio__item' : 'radio__item'}>
                                    <input type="radio" onChange={this.handleReceiveUpdate} value="no" name="isReceiveUpdate" id="irno" checked={isReceiveUpdate === 'no'} />
                                    <label htmlFor="irno">No</label>
                                </div>
                            </div>

                                    <div className="align-horizontal">
                                        <label htmlFor="email" className="question-helper">Email</label>
                                        <input type="email" id="email" name="email" placeholder="Please enter your email" onChange={this.handleChange} />
                                    </div>
                                    <ValidatorComponent name='email' messages={validatorMessages}></ValidatorComponent>
                        </div>
                    }
                    </>
                }
                <div className={validatorMessages.length ? "question-section question-section__error" : "question-section"}>
                    <span className="primary-question">Send your report to council</span>
                    <span className="question-helper">Choose the button below to send us your report, we will use it to monitor and improve the impact of odour in your area.</span>
                    <ValidatorSummaryComponent messages={validatorMessages}></ValidatorSummaryComponent>

                    <button onClick={this.submitClicked}>SUBMIT ODOUR REPORT</button>
                </div>
            </div >
        );
    }
}

export default OdourAssessment;
